import { browser } from '$app/environment';

export function isChrome(): boolean {
    if (!browser) {
        throw new Error('Browser not found');
    }
    const isChromium = 'chrome' in window;
    const winNav = window.navigator;
    const userAgent = winNav.userAgent || '';
    const vendorName = winNav.vendor;
    const isOpera = 'opr' in window;
    const isIEedge = userAgent.indexOf('Edg') > -1;
    const isIOSChrome = Boolean(userAgent.match('CriOS'));

    return isIOSChrome || (isChromium !== null
        && typeof isChromium !== 'undefined'
        && vendorName === 'Google Inc.'
        && !isOpera
        && !isIEedge
    );
}

export const checkInUA = (parts: string[]): boolean => {
    const userAgent: string = window.navigator.userAgent;

    if (userAgent == null) {
        return false;
    }

    const lcUserAgent = String(userAgent).toLowerCase();
    const lcParts = parts.map((p) => p.toLowerCase());

    return lcParts.some((p) => lcUserAgent.includes(p));
};

export const isIPhone = (): boolean => checkInUA(['iPhone']);

export const isIPad = (): boolean =>
    checkInUA(['iPad']) ||  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isIos = (): boolean => isIPad() || isIPhone() || checkInUA(['iPod']);

export function getIosVersion(): { major: number; minor: number } | null {
    if (!isIos()) {
        return null;
    }

    const match = navigator.userAgent.match(/OS ([\d_]+)/);
    if (!match) {
        return null;
    }

    const version = match[1].split('_');
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    return { major, minor };
}

export const isAndroid = (): boolean => {
    if (!browser) {
        throw new Error('Browser not found');
    }

    return checkInUA(['android']);
};

export const isIosSafari = () => isIos() && checkInUA(['Safari']) && !checkInUA([
    'CriOS',
    'FxiOS',
    'EdgiOS',
    'OPiOS',
    'GSA',
    'DuckDuckGo',
    'SamsungBrowser',
]);

export const isIosWebView = () => isIos() && !checkInUA(['Version']);

export const isEdge = () => checkInUA(['Edg', 'EdgiOS', 'EdgA']);

export function isFirefox() {
    if (!browser) {
        throw new Error('Browser not found');
    }
    const { userAgent } = window.navigator;
    return !isChrome()
        && (
            userAgent.indexOf('Firefox') !== -1
            || userAgent.indexOf('FxiOS') !== -1
        );
}

export function isTouch() {
    if (!browser) {
        throw new Error('Browser not found');
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return 'ontouchstart' in window;
}

export function isMobileOS(): boolean {
    return isAndroid() || isIos();
}
